import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PaginationLimit } from "../../Config";
import tw from "tailwind-styled-components";
import Images from "../../Images";
// import { PrevBtn, NextBtn, PaginationWrapper } from "../../Components/Styles/InputStyle2";
import { IoMdMore } from "react-icons/io";
import { FaLink, FaUser } from "react-icons/fa";
import { MdModeEditOutline } from "react-icons/md";
import { FaFemale, FaMale } from "react-icons/fa";

import {
  FaHome,
  FaTools,
  FaBolt,
} from "react-icons/fa";
import { FiEdit2 } from "react-icons/fi";
import { capitalizeFirstLetter } from "../../helpers";
import NotFoundModel from "../../Components/NotFoundModel";

const Tables = ({ apiData, setSelectedData, setIsEditStaff, setLinkStaff, setIsStaffSummary }) => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [previousId, setPreviousId] = useState(null);
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const edit = (item) => {
    setIsEditStaff(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };
  const linkUnlink = (item) => {
    setLinkStaff(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };
  const staffSummary = (item) => {
    setIsStaffSummary(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };
  const ActionBtns = (item) => {
    const openMenu = (id) => {
      setPreviousId(openActionMenu);
      setOpenActionMenu((prevId) => {
        return prevId === id ? null : id;
      });
    };

    return (
      <ActionBtnWrapper>
        {openActionMenu === item.id && (
          <MenuOptions id="menuOptions">
            <MenuItem
              title="Edit Staff"
              onClick={() => {
                edit(item)
              }}
            >
              <MdModeEditOutline className="text-gray-700 " /> Edit Staff
            </MenuItem>
            {item.status === 1 &&
              <MenuItem
                onClick={() => {
                  linkUnlink(item)
                }}
              >
                <FaLink className="text-gray-700 " /> Link - Unlink
              </MenuItem>}
            {/* <MenuItem
              onClick={() => {
                staffSummary(item)
              }}
            >
              <FaUser className="text-gray-700 " /> Staff Summary
            </MenuItem> */}
          </MenuOptions>
        )}
        <Btn title="Actions" type="button" onClick={() => openMenu(item.id)}>
          <IoMdMore className="text-gray-600" size={24} />
        </Btn>
      </ActionBtnWrapper>
    );
  };
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const getRole = (indx) => {
    switch (parseInt(indx)) {
      case 1:
        return 'Admin';
      case 2:
        return 'Warden';
      case 3:
        return 'Electrician';
      case 4:
        return 'Plumber';
      case 5:
        return 'Laundry';
      case 6:
        return 'Carpenter';
      case 7:
        return 'Partner';
      default:
        return (
          <p className="bg-rose-100 text-gray-500 text-xs border-rose-300 border py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
            <FaTools className="inline mr-2 text-gray-500" />
            Not assigned
          </p>
        );
    }
  };

  // const getRole = (indx) => {
  //   switch (parseInt(indx)) {
  //     case 1:
  //       return (
  //         <p className="bg-teal-100 text-gray-500 border-teal-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
  //           <FaUserShield className="inline mr-2 text-gray-500" />
  //           Admin
  //         </p>
  //       );
  //     case 2:
  //       return (
  //         <p className="bg-lime-100 text-gray-500 border-lime-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
  //           <FaHome className="inline mr-2 text-gray-500" />
  //           Warden
  //         </p>
  //       );
  //     case 3:
  //       return (
  //         <p className="bg-amber-100  text-grayr-500 border-amber-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
  //           <FaBolt className="inline mr-2 text-gray-500" />
  //           Electrician
  //         </p>
  //       );
  //     case 4:
  //       return (
  //         <p className="bg-indigo-100 text-gray-500 border-indigo-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
  //           <FaWrench className="inline mr-2 text-gray-500" />
  //           Plumber
  //         </p>
  //       );
  //     case 5:
  //       return (
  //         <p className="bg-indigo-100 text-gray-500 border-indigo-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
  //           <FaWrench className="inline mr-2 text-gray-500" />
  //           Laundry
  //         </p>
  //       );
  //     case 6:
  //       return (
  //         <p className="bg-indigo-100 text-gray-500 border-indigo-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
  //           <FaWrench className="inline mr-2 text-gray-500" />
  //           Carpenter
  //         </p>
  //       );
  //     case 7:
  //       return (
  //         <p className="bg-blue-100 text-blue-500 border-blue-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
  //           <FaUserShield className="inline mr-2 text-gray-500" />
  //           Partner
  //         </p>
  //       );
  //     default:
  //       return (
  //         <p className="bg-rose-100 text-gray-500 text-xs border-rose-300 border py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
  //           <FaTools className="inline mr-2 text-gray-500" />
  //           Not assigned
  //         </p>
  //       );
  //   }
  // };

  const getGender = (gender) => {
    if (gender === 1) {
      return "Male";
    } else {
      return "Female";
    }
  };

  const getName = (item) => {
    return (
      <UserImageWrapper>
        {item.gender === 1 ? (
          <FaMale className="text-gray-400 w-8 h-8" />
        ) : (
          <FaFemale className="text-gray-400 w-8 h-8" />
        )}
        <div className="flex gap-1 flex-col">
          <span className="text-gray-600 text-sm">
            {capitalizeFirstLetter(item.name)}
          </span>
        </div>
      </UserImageWrapper>
    );
  };

  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        mobile: <span className='text-gray-600 text-sm'>{'#' + item.mobile}</span>,
        role: <span className='bg-neutral-50 px-3 py-1 rounded-md text-gray-600 text-sm'>{getRole(item.role)}</span>,
        action: ActionBtns(item),
        status:
          item.status == 1 ? (
            <div className="bg-green-100 text-green-700 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded-full">
              Active
            </div>
          ) : (
            <div className="bg-gray-100 text-gray-700 text-xs border-gray-300 border w-24 h-7 flex items-center justify-center rounded-full">
              Inactive
            </div>
          ),
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const columns = useMemo(() => {
    if (isMobileView) {
      // Display only "User" column for mobile screens
      return [
        {
          Header: "Name",
          accessor: "name",
        },
        {
          Header: "Salary",
          accessor: "Salary",
        },
      ];
    }

    // Columns for larger screens
    return [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Mobile",
        accessor: "mobile",
      },
      {
        Header: "Role",
        accessor: "role",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Attendance",
        accessor: "",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );
  useEffect(() => {
    setCurrentPage(pageIndex); // Update current page on state change
  }, [pageIndex]);
  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Role:</strong> {data[rowIndex].Role}
                        </li>

                        <li className="flex gap-2">
                          <strong>Status:</strong> {data[rowIndex].status}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>
          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75 "
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
      {apiData?.length === 0 && <NotFoundModel />}
    </>
  );
};
const UserImageWrapper = tw.div` flex items-center gap-2`;

const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-medium cursor-pointer hover:bg-gray-100`;
const MenuOptions = tw.div`absolute bottom-10 right-0 py-2 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const ActionBtnWrapper = tw.div`flex items-center gap-1 relative`;
// const ActionBtnWrapper = tw.div`grid xl:grid-cols-2 md:grid-cols-1 grid-cols-4 w-40 mb-1 gap-y-1 gap-x-1.5 md:w-16 mt-3 md:mt-0`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const PaginationWrapper = tw.div`flex mt-5 justify-end gap-3 items-center text-sm text-gray-400 mr-2 mb-2`;
const NextBtn = tw.div`w-8  h-8 rounded-full cursor-pointer disabled:opacity-25 disabled:cursor-not-allowed text-sm  border border-gray-300 text-gray-300 hover:text-gray-700 hover:border-gray-700  flex justify-center items-center  `; const PrevBtn = tw.div`w-8  h-8 rounded-full cursor-pointer disabled:opacity-25 disabled:cursor-not-allowed  text-sm  border border-gray-300 text-gray-300 hover:text-gray-700 hover:border-gray-700 flex justify-center items-center  `;

export default Tables;
